export default __webpack_public_path__ + "static/media/measure_img.ecd8a7bd.png";